export const UrlTabsHelper = {
	paramName: "tab",
	listeners: new Set(),

	/** Get the active tab from the URL */
	getTabFromUrl() {
		const params = new URLSearchParams(window.location.search);
		return params.get(this.paramName);
	},

	/** Set the active tab in the URL */
	setTabInUrl(tab) {
		const params = new URLSearchParams(window.location.search);
		const currentTab = params.get(this.paramName);

		// Prevent pushing the same tab again
		if (currentTab === tab) return;

		params.set(this.paramName, tab);
		const newUrl = `${window.location.pathname}?${params.toString()}`;
		// Update the browser history with the new tab
		window.history.pushState({}, "", newUrl);
		this._notifyListeners();
	},

	/** Add a listener for URL changes. Returns an unsubscribe function. */
	subscribe(callback) {
		this.listeners.add(callback);
		return () => this.listeners.delete(callback);
	},

	// Notify all listeners about the tab change
	_notifyListeners() {
		const tab = this.getTabFromUrl();
		this.listeners.forEach((cb) => cb(tab));
	},

	/** Initialize popstate event listening (for browser navigation) */
	init() {
		if (this._isInitialized) return;
		this._isInitialized = true;
		// Listen for browser navigation events (back/forward)
		window.addEventListener("popstate", () => this._notifyListeners());
	},
};
